import { render, staticRenderFns } from "./viewDataInfo.vue?vue&type=template&id=bc5f9368&scoped=true"
import script from "./viewDataInfo.vue?vue&type=script&lang=js"
export * from "./viewDataInfo.vue?vue&type=script&lang=js"
import style0 from "./viewDataInfo.vue?vue&type=style&index=0&id=bc5f9368&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc5f9368",
  null
  
)

export default component.exports